






















// vendor
import { defineComponent, ref, computed } from "@vue/composition-api";
import * as SessionAPI from "@/services/api/sessions";
import * as StudyAPI from "@/services/api/studies";
import { StudyInfo } from "@psychlab/types";
import { FacebookWarning } from "@/components.run/facebook-warning";
import * as Platform from "@utils/platform";
import { default as Loading } from "./screens/loading.vue";
import { default as Locked } from "./screens/locked.vue";
import { default as NotFound } from "./screens/not-found.vue";
import { default as Start } from "./screens/start-session.vue";
import { default as Resume } from "./screens/resume-session.vue";
import { AbsBox } from "@ui";

export default defineComponent({
	components:{
		AbsBox,
		Loading,
		Locked,
		NotFound,
		Start,
		Resume,
		FacebookWarning,
	},
	setup(_, context){

		const hasError = ref(false);
		const loading = ref(false);
		const notFound = ref(false);
		const info = ref<StudyInfo>();
		const started = ref(false);
		const existingSession = ref<string>();
		
		const isFacebook = computed(() => {
			return Platform.isFacebookApp();
		});

		const disabled = computed(() => info.value ? !info.value.enabled : false);

		const displayLanguage = computed(() => {
			if(!info.value){ return ""; }
			// const lang = (info.value.language || context.root.$route.query["l"]) || "en";
			let l = info.value.language || "en";
			if(context.root.$route.query["l"]){
				l = context.root.$route.query["l"] as string;
			}
			return l;
		});

		const start = async() => {
			started.value = true;
			await instantiateProxy();
		};

		const resume = () => {
			started.value = true;
			if(!existingSession.value){ return; }
			openSession(existingSession.value);
		};

		const openSession = (sessionId:string) => {
			context.root.$router.push({
				name:"Run.Session",
				params:{
					sessionId
				},
				query:{ l:displayLanguage.value }
			});
		};

		const instantiateProxy = async() => {
			loading.value = true;
			const studyId = context.root.$route.params["proxyId"];
			try{
				const { token, session } = await StudyAPI.runStudy(studyId);
				SessionAPI.saveSessionToken(studyId, session, token);
				openSession(session);
			}
			catch({ response }){
				hasError.value = true;
			}
			loading.value = false;
		};

		const init = async() => {
			try {
				info.value = await StudyAPI.getStudyInfo(context.root.$route.params["proxyId"]);
				existingSession.value = SessionAPI.findActiveStudySession(context.root.$route.params["proxyId"]);
				context.root.$store.commit("localization/setPreferredLanguage", displayLanguage.value);
			}
			catch(err){
				notFound.value = true;
			}
		};

		init();

		return {
			hasError,
			loading,
			notFound,
			info,
			started,
			existingSession,
			disabled,
			displayLanguage,
			isFacebook,
			start,
			resume,
		};
	}
});

